export const PRODUCT_UNIT = 'ProductUnit';
export const ProductUnitKindValues = [
    'packaging',
    'measure',
];
/** pt-BR labels for {@link ProductUnitKind}. */
export const PRODUCT_UNIT_KIND_LABELS = {
    packaging: 'Embalagem',
    measure: 'Medida',
};
//# sourceMappingURL=product-unit.js.map